import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-currency-field', observe: true })
export class CurrencyFieldComponent {

    inputElement: HTMLInputElement;
    currency: string;
    constructor(private element: HTMLElement) {
        this.inputElement = element as HTMLInputElement;
        this.currency = this.inputElement.getAttribute('data-currency');
        this.init();
    }

    private init() {
        if (this.inputElement) {
            this.formatInputField();
            // Format on blur (when user leaves the field)
            this.inputElement.addEventListener('blur', () => {
                 this.formatInputField();
            });

            // Remove formatting on focus (makes editing easier)
            this.inputElement.addEventListener('focus', function (this: HTMLInputElement): void {
                const value = this.value.replace(/[^\d]/g, '');
                this.value = value;
            });

            // Handle form submission - convert back to numeric value
            const form = this.inputElement.closest('form');
            if (form) {
                form.addEventListener('submit', function (e: Event): void {
                    // Convert formatted value to numeric before submission
                    const numericValue = this.inputElement.value.replace(/[^\d]/g, '');
                    this.inputElement.value = numericValue;
                });
            }
        }
    }

    private formatInputField() {
        const value = this.inputElement.value.replace(/[^\d]/g, ''); // Remove non-numeric characters
        if (value) {
            const numValue = parseInt(value, 10);
            if (!isNaN(numValue)) {
                this.inputElement.value = this.formatCurrency(numValue, this.currency);
            }
        }
    }



    /**
 * Format number as currency matching C# GetCurrencyFormated method
 * @param number - The number to format
 * @param currency - Currency code (CHF or EUR)
 * @returns Formatted currency string with non-breaking spaces
 */
    private formatCurrency(number: number, currency: string): string {
        if (number <= 0) {
            number = 0;
        };

        // Format number with thousand separator using apostrophe
        let formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        if (currency.toLowerCase() === 'eur') {
            // EUR format: EUR  10.000
            // Replace both straight apostrophe (') and typographic apostrophe (') with dot
            formattedNumber = formattedNumber.replace(/['\']/g, '.');
            return `${currency}  ${formattedNumber}`;
        } else {
            // CHF format: CHF  10'000.–
            return `${currency}  ${formattedNumber}.–`;
        }
    }
}